import { Space, Table, Modal, Form, Radio as _Radio, Input, Select, message } from 'antd'
import './index.less'
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import {
  getManageList,
  insertManageItem as _insertManageItem,
  deleteManageItem,
  saveManageItem
} from '@/server'
import { useAppSelector } from '@/hooks'

function DataPageFunc(props, ref) {
  const token = useAppSelector((state) => state.login.token)
  interface DataType {
    key: string
    ruleName: string
    urls: any
    used: any
    permission: string
  }

  const defaultRuleData: Array<DataType> = []
  let curRuleData: Array<DataType> = []

  const getBackendData = () => {
    getManageList({}, 'rule', token)
      .then((res) => {
        curRuleData = []
        const rawRuleList = res.data.content
        for (const rule of rawRuleList) {
          curRuleData.push({
            key: rule.ruleid,
            ruleName: rule.rulename,
            urls: rule.urls,
            used: rule.used,
            permission: rule.permission
          })
        }
        setRuleData(curRuleData)
        updateDicts()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useImperativeHandle(ref, () => ({
    rerender: () => {
      getBackendData()
    }
  }))

  useEffect(() => {
    getBackendData()
  }, [])

  const [ruleData, setRuleData] = useState(defaultRuleData)
  const [curEditRuleKey, setCurEditRuleKey] = useState('')
  const [curEditRuleName, setCurEditRuleName] = useState('')
  const [curEditDataPath, setCurEditDataPath] = useState(Array<any>)
  const [curEditUsed, setCurEditUsed] = useState(Array<any>)
  const [curEditPermission, setCurEditPermission] = useState('')
  const [curDelRuleKey, setCurDelRuleKey] = useState('')
  // let curEditRuleKey, curEditRuleName, curEditDataPath, curEditUsed, curEditPermission, curDelRuleKey

  const [open, setOpen] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)

  const [keyToName, setKeyToName] = useState({})
  const updateDicts = () => {
    const tmpKeyToName = {}
    for (const rule of ruleData) {
      tmpKeyToName[rule.key] = rule.ruleName
    }
    setKeyToName(tmpKeyToName)
  }
  useEffect(() => {
    updateDicts()
  }, [ruleData])

  const columns = [
    {
      title: '规则名称',
      dataIndex: 'ruleName',
      key: 'ruleName',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.ruleName.localeCompare(b.ruleName)
    },
    {
      title: '数据路径',
      dataIndex: 'urls',
      key: 'urls',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.urls.localeCompare(b.urls),
      render: (text, _record, _index) => {
        const str = text?.join(', ')
        return <div>{str}</div>
      }
    },
    {
      title: '可用于',
      dataIndex: 'used',
      key: 'used',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.used.localeCompare(b.used),
      render: (text, _record, _index) => {
        const str = text?.join(', ')
        return <div>{str}</div>
      }
    },
    {
      title: '权限',
      dataIndex: 'permission',
      key: 'permission',
      // defaultSortOrder: 'ascend',
      sorter: (a, b) => a.permission.localeCompare(b.permission)
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <a
            style={{ color: 'rgb(136, 113, 52)' }}
            onClick={(_e) => {
              console.log(record)
              setCurEditRuleKey(record.key)
              setCurEditRuleName(record.ruleName)
              setCurEditDataPath(record.urls)
              setCurEditUsed(record.used)
              setCurEditPermission(record.permission)
              // curEditRuleKey = record.key
              // curEditRuleName = record.ruleName
              // curEditDataPath = record.urls
              // curEditUsed = record.used
              // curEditPermission = record.permission
              // console.log(curEditRuleKey, curEditRuleName, curEditDataPath, curEditUsed, curEditPermission)
              setOpen(true)
            }}
          >
            编辑
          </a>
          <a
            style={{ color: 'rgb(136, 113, 52)' }}
            onClick={(_e) => {
              setCurDelRuleKey(record.key)
              // curDelRuleKey = record.key
              setConfirmOpen(true)
            }}
          >
            移除
          </a>
        </Space>
      )
    }
  ]

  const [form] = Form.useForm()
  const onEdit = (values) => {
    console.log(values, props.ruleToId)
    saveManageItem(
      {
        ruleid: curEditRuleKey,
        urls: values.urls,
        permission: values.permission,
        used: values.used.map((item) => props.groupToId[item])
      },
      'rule',
      token
    )
      .then((_res) => {
        message.success('修改成功！')
        getBackendData()
        setOpen(false)
      })
      .catch((err) => {
        message.error('修改失败，请重试！')
        console.log(err)
      })
  }
  return (
    <>
      <Modal
        open={confirmOpen}
        title='提示'
        okText='确定'
        cancelText='取消'
        onCancel={() => {
          setConfirmOpen(false)
        }}
        onOk={() => {
          deleteManageItem(curDelRuleKey, 'rule', token)
            .then((_res) => {
              message.success('删除成功！')
              const tmpRuleData = ruleData.filter((item) => item.key !== curDelRuleKey)
              setRuleData(tmpRuleData)
              updateDicts()
              getBackendData()
              setConfirmOpen(false)
            })
            .catch((err) => {
              message.error('删除失败，请重试！')
              console.log(err)
            })
        }}
      >
        是否确认移除{keyToName[curDelRuleKey]}
      </Modal>
      <Modal
        open={open}
        title='编辑规则信息'
        okText='确定'
        cancelText='取消'
        onCancel={() => {
          setOpen(false)
        }}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields()
              onEdit(values)
            })
            .catch((info) => {
              console.log('Validate Failed:', info)
            })
        }}
      >
        <Form form={form} layout='vertical' name='edit' initialValues={{ modifier: 'public' }}>
          <Form.Item
            name='ruleName'
            label='规则名称'
            initialValue={curEditRuleName}
            rules={[
              {
                required: true,
                message: '请输入规则名称'
              }
            ]}
          >
            <Input placeholder='请输入规则名称' />
          </Form.Item>
          <Form.Item
            name='urls'
            label='数据路径'
            initialValue={curEditDataPath}
            rules={[
              {
                required: true,
                message: '请选择数据路径'
              }
            ]}
          >
            <Select mode='multiple' options={props.dataPathOptions} placeholder='请选择数据路径' />
          </Form.Item>
          <Form.Item
            name='used'
            label='可用于'
            initialValue={curEditUsed}
            rules={[
              {
                required: true,
                message: '请选择适用范围'
              }
            ]}
          >
            <Select mode='multiple' options={props.groupOptions} placeholder='请选择适用范围' />
          </Form.Item>
          <Form.Item
            name='permission'
            label='权限'
            initialValue={curEditPermission}
            rules={[
              {
                required: true,
                message: '请选择权限'
              }
            ]}
          >
            <Select options={props.permissionOptions} />
          </Form.Item>
        </Form>
      </Modal>
      <Table columns={columns} dataSource={ruleData} />
    </>
  )
}

const DataPage = forwardRef(DataPageFunc)
export { DataPage }
